import mitt, { Emitter } from 'mitt'

type Events = {
    "update:counters": void;
    "update:max-pages": number;
};

const emitter: Emitter<Events> = mitt<Events>();

export function useEmitter(): Emitter<Events> {
    return emitter;
}